import { render, staticRenderFns } from "./SmallAddress.vue?vue&type=template&id=06bdf39a&scoped=true"
import script from "./SmallAddress.vue?vue&type=script&lang=js"
export * from "./SmallAddress.vue?vue&type=script&lang=js"
import style0 from "./SmallAddress.vue?vue&type=style&index=0&id=06bdf39a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdf39a",
  null
  
)

export default component.exports